export default theme => ({
  radioGroup: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});
